var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',_vm._b({attrs:{"value":_vm.value,"items":_vm.items,"label":_vm.label || '',"color":"primary","hide-no-data":"","hide-selected":"","item-text":_vm.text,"item-value":_vm.indicator,"error-messages":_vm.errors || []},on:{"input":_vm.onEdit}},'v-autocomplete',_vm.customProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }